import { RisebinarQuery } from "@interfaces/risebinar"
import KyMethod from "./KyMethod"

export default class RisebinarRepositories extends KyMethod {
  protected async getRawRisebinarList(query?: Partial<RisebinarQuery>) {
    return this._getData("/risebinars", query)
  }
}
